import {ReactElement, useId} from 'react'
import classNames from 'classnames'

import './DopamineAssistantMark.css'

interface DopamineAssistantMarkProps {
  animated?: boolean
  className?: string
  gradient?: boolean
}

const SPARKLE_MAIN =
  'M10.5 6C11 10.2 13.3 12.5 17.5 13C13.3 13.5 11 15.8 10.5 20C10 15.8 7.7 13.5 3.5 13C7.7 12.5 10 10.2 10.5 6Z'
const SPARKLE_COMPANION =
  'M18 3.5C18.2 5.7 19.3 6.8 21.5 7C19.3 7.2 18.2 8.3 18 10.5C17.8 8.3 16.7 7.2 14.5 7C16.7 6.8 17.8 5.7 18 3.5Z'

export const DopamineAssistantMark = ({
  animated = false,
  className,
  gradient = false,
}: DopamineAssistantMarkProps): ReactElement => {
  const baseId = useId().split(':').join('')
  const gradientId = `${baseId}-gradient`
  const auroraId = `${baseId}-aurora`
  const mainClipId = `${baseId}-clip-main`
  const companionClipId = `${baseId}-clip-companion`

  return (
    <svg
      aria-hidden="true"
      className={classNames('shrink-0', className)}
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      {animated ? (
        <>
          <defs>
            <clipPath id={mainClipId}>
              <path d={SPARKLE_MAIN} />
            </clipPath>
            <clipPath id={companionClipId}>
              <path d={SPARKLE_COMPANION} />
            </clipPath>
            {/* lilac aurora that drifts through both sparkles while thinking */}
            <linearGradient
              id={auroraId}
              gradientUnits="userSpaceOnUse"
              x1="0"
              x2="28"
              y1="4"
              y2="12"
            >
              <stop className="dopamine-mark-aurora-edge" offset="0" />
              <stop className="dopamine-mark-aurora-mid" offset="0.5" />
              <stop className="dopamine-mark-aurora-edge" offset="1" />
            </linearGradient>
          </defs>
          <g
            className="dopamine-progress-mark-main"
            clipPath={`url(#${mainClipId})`}
          >
            <rect
              className="dopamine-mark-aurora"
              fill={`url(#${auroraId})`}
              height="24"
              width="40"
              x="-8"
              y="0"
            />
          </g>
          <g
            className="dopamine-progress-mark-companion"
            clipPath={`url(#${companionClipId})`}
          >
            <rect
              className="dopamine-mark-aurora"
              fill={`url(#${auroraId})`}
              height="24"
              width="40"
              x="-8"
              y="0"
            />
          </g>
        </>
      ) : (
        <>
          {gradient ? (
            <defs>
              <linearGradient
                id={gradientId}
                gradientUnits="userSpaceOnUse"
                x1="3"
                x2="22"
                y1="4"
                y2="20"
              >
                <stop stopColor="#4BD1FF" />
                <stop offset="1" stopColor="#C580FF" />
              </linearGradient>
            </defs>
          ) : null}
          <g fill={gradient ? `url(#${gradientId})` : 'currentColor'}>
            <path d={SPARKLE_MAIN} />
            <path d={SPARKLE_COMPANION} />
          </g>
        </>
      )}
    </svg>
  )
}
